import React, { useState, useEffect } from "react";
import { Host,Port} from '../Routes/apiConfig';
import { ResponsiveContainer } from "recharts"; // Import ResponsiveContainer
import emptyImage from '../images/emptyImage.png'
import {
  Table,
  DatePicker,
  Button,
  Modal,
  Form,
  message,
  Input,
  Space,
  Layout,
  Image,
  Skeleton,
  Spin 
} from "antd";
import { useNavigate } from "react-router-dom";
import {SearchOutlined,EditOutlined,DeleteOutlined,LoadingOutlined} from "@ant-design/icons";
import Cookies from "js-cookie";
import Axios from "axios";
import { useLayout } from "../../src/LayoutContext";
import MyHeader from "../compo/Header";
import { useTranslation } from "react-i18next";

const Products = ({colorTheme}) => {
  const { isLtr } = useLayout();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const sessionKey = Cookies.get("sessionKeySwin");
  useEffect(() => {
    const sessionKey = Cookies.get("sessionKeySwin");
    if (!sessionKey) {
      navigate("/login");
    }
  }, [navigate]);
  /*********************************************************/
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const [form] = Form.useForm();
  const [loadingImages, setLoadingImages] = useState(true);
  const headers={
    headers: {
      "hyazs-session-key": sessionKey,
      "HYAZS-API-KEY":
        "rYJ1riRCUqRHMwQH47UCOYwPnfigX1X-aeeTVYyxVTSWKsSup0VXS-K1",
    },
  }
  /*********************************************************/
  const fetchData = async () => {
    try {
      const productsApi=`${Host}:${Port}/admin/products`;

      const response = await Axios.get(productsApi,headers);
      if (response.data.statusCode < 0 && response.data.statusCode !== -101) {
        message.error(response.data.message);
      } else if (response.data.statusCode === -101) {
        Cookies.remove("sessionKeySwin");
        navigate("/login");
      } else {
        setData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  /*********************************************************/
  const editRecord = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    setVisible(true);
  };

  const deleteRecord = async (id) => {
    try {
      await Axios.delete("/api/records/delete", { data: { id } });
      fetchData();
    } catch (error) {
      console.error("Failed:", error);
    }
  };
  /*********************************************************/
  const handleOk = async (e) => {
    e.preventDefault();

    try {
      const values = await form.validateFields();

      if (editingRecord) {
        const updatedData = {
          id: editingRecord.id,
          mobile: values.mobile,
          password: values.password,
        };

        await Axios.put(
          `${Host}:${Port}/admin/subscribers`,
          updatedData,
          {
            headers: {
              "hyazs-session-key": sessionKey,
              "HYAZS-API-KEY":
                "rYJ1riRCUqRHMwQH47UCOYwPnfigX1X-aeeTVYyxVTSWKsSup0VXS-K1",
            },
          }
        )
          .then((response) => {
            if (response.data.statusCode === 0) {
              message.warning("Your custom warning message goes here");
            } else {
              message.success("Update successful"); // Show a success message for a successful update
            }
            fetchData();
          })
          .catch((error) => {
            // Handle an error
            console.error("Update Error:", error);
          });
      }
      fetchData();
      setVisible(false);
      form.resetFields();
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  /*********************************************************/
  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      // sorter: (a, b) => a.key - b.key,
      onFilter: (value, record) => record.id.toString().includes(value), // Use 'id' here
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search ID"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },
    isLtr
      ? {
          title: t("formLabels.productsInfo.productName"),
          dataIndex: ["name", "en"],
          key: "en",
          render: (value) => {
            return value !== null ? value : "none";
          },
          // sorter: (a, b) => a.value - b.value,
          onFilter: (value, record) =>
            record.name.en.toLowerCase().includes(value.toLowerCase()), // Use 'email' here
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              <Input
                placeholder={t("formLabels.productsInfo.searchProductName")}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
              <Button
                type="primary"
                onClick={() => confirm()}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90, marginRight: 8 }}
              >
                Search
              </Button>
              <Button
                onClick={() => clearFilters()}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </div>
          ),
          filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
        }
      : {
          title: t("formLabels.productsInfo.productName"),
          dataIndex: ["name", "ar"],
          key: "ar",
          render: (value) => {
            return value !== null ? value : "none";
          },
          // sorter: (a, b) => a.value - b.value,
          onFilter: (value, record) =>
            record.name.ar.toLowerCase().includes(value.toLowerCase()), // Use 'email' here
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              <Input
                placeholder={t("formLabels.productsInfo.searchProductName")}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
              <Button
                type="primary"
                onClick={() => confirm()}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90, marginRight: 8 }}
              >
                Search
              </Button>
              <Button
                onClick={() => clearFilters()}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </div>
          ),
          filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
        },
    {
      title: t("formLabels.productsInfo.price"),
      dataIndex: "price",
      key: "price",
      render: (value) => {
        return value !== null ? value : "none";
      },
      // sorter: (a, b) => a.value - b.value,
      onFilter: (value, record) =>
        record.price.toLowerCase().includes(value.toLowerCase()), // Use 'email' here
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={t("formLabels.productsInfo.searchPrice")}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },
    {
      title: t("formLabels.productsInfo.quantity"),
      dataIndex: "quantity",
      key: "quantity",
      render: (value) => {
        return value !== null ? value : "none";
      },
      // sorter: (a, b) => a.value - b.value,
      onFilter: (value, record) => record.quantity?.toString().includes(value), // Use 'mobile' here
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={t("formLabels.productsInfo.searchQuantity")}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },
    isLtr
      ? {
          title: t("formLabels.productsInfo.description"),
          dataIndex: ["description", "en"],
          key: "en",
          render: (value) => {
            return value !== null ? value : "none";
          },
        }
      : {
          title: t("formLabels.productsInfo.description"),
          dataIndex: ["description", "ar"],
          key: "ar",
          render: (value) => {
            return value !== null ? value : "none";
          },
        },
        // {
        //   title: "Image",
        //   dataIndex: "mainImage",
        //   key: "mainImage",
        //   render: (text, record) => (
        //     <Image
        //       src={record.mainImage} // Replace 'imageURL' with the actual data field containing image URLs in your 'data'
        //       alt="Product Image"
        //       width={80} // Adjust the width as needed
        //       height={80} // Adjust the height as needed
        //       style={{ borderRadius: "30%" }}
        //       onError={(e) => {
        //         e.target.src = emptyImage; // Replace with the placeholder image when the image fails to load
        //       }}
        //     />
        //   ),
        // },
        {
          title: "Image",
          dataIndex: "list_of_images",
          key: "list_of_images",
          render: (text) => (
            <Skeleton loading={false} active>
              <Image
            src={`https://s-assets.swin.me/images/products/${text}`}
            alt="Product Image"
            width={80}
            height={80}
            style={{ borderRadius: "30%" }}
            preview={true} // Disable preview to prevent unexpected behavior
             onLoad={() => setLoadingImages(false)}
            onError={(e) => {
              e.target.src = emptyImage;
              setLoadingImages(false);
            }}
          />
            </Skeleton>
          ),
        },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space size="middle">
          <Button className="custom-edit-button" type="primary" icon={<EditOutlined />} onClick={() => editRecord(record)}>{t("table.edit")}</Button>
          <Button className="custom-delete-button" type="danger" icon={<DeleteOutlined />} disabled onClick={() => deleteRecord(record.id)}>
            {t("table.delete")}
          </Button>
        </Space>
      ),
    },
  ];
  const customTableHeader = () => (
    <div>
      <span
        style={{
          background: "linear-gradient(to right, #7684af, #21daff)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: "28px",
          fontWeight: "bold",
        }}
      >
        {t("menu.products")}
      </span>
      {/* <Button type="primary" onClick={() => setVisible(true)}>
        {t("table.add")}
      </Button> */}
    </div>
  );
  return (
    <Layout dir={isLtr ? "ltr" : "rtl"}>
      <div className={`modern-table-container ${colorTheme==="dark"?"dark-mode":''}`}>
        <MyHeader
          // DrawerTitle="This is the drawer title"
          // DrawerFooter="This is the drawer footer"
          HeadercolorTheme={colorTheme}
        />
        <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24 }} />}>
        <Table
          className="custom-table"
          columns={columns}
          dataSource={data}
          rowKey="id"
          pagination={{ defaultPageSize: 10 }}
          onChange={fetchData}
          // expandable={{
          //   expandedRowRender: () => (
          //     <Button onClick={() => setVisible(true)}>Add Record</Button>
          //   ),
          // }}
          title={customTableHeader}
          scroll={{ x: '100%' }}
        />
        </Spin>
        <Modal
          title={editingRecord ? t("table.edit") : t("table.add")}
          open={visible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Form form={form} layout="vertical">
            {!editingRecord ? (
              <Form.Item
                label="User name"
                name="userName"
                rules={[
                  {
                    required: true,
                    message: "Please enter a user name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            ) : (
              ""
            )}
            <Form.Item
              label="Mobile"
              name="mobile"
              rules={[
                {
                  required: true,
                  message: "Please enter a mobile number!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter a password!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </Layout>
  );
};

export default Products;
